import { MessagesMockApi } from 'app/mock-api/common/messages/api';
import { NavigationMockApi } from 'app/mock-api/common/navigation/api';
import { ShortcutsMockApi } from 'app/mock-api/common/shortcuts/api';
import { ActivitiesMockApi } from 'app/mock-api/pages/activities/api';
import { DataVisualBarMockApi } from './dashboards/dv-bar/api';

export const mockApiServices = [
    ActivitiesMockApi,
    MessagesMockApi,
    NavigationMockApi,
    ShortcutsMockApi,
    DataVisualBarMockApi,
];
